export type ComparisonRequirement = { label: string; met: boolean };

export function partitionComparisonRequirements(
  items: ComparisonRequirement[] | null | undefined,
): { met: ComparisonRequirement[]; failed: ComparisonRequirement[] } {
  const list = Array.isArray(items) ? items : [];
  return {
    met: list.filter((item) => item.met),
    failed: list.filter((item) => !item.met),
  };
}

export function comparisonFailureLabels(
  items: ComparisonRequirement[] | null | undefined,
  comparable?: boolean | null,
): string[] {
  const { failed } = partitionComparisonRequirements(items);
  if (failed.length > 0) return failed.map((item) => item.label);
  if (comparable === false) return [];
  return [];
}
